<div class="press-release-container">
    <div class="title">
        <h4 translate>PRESS_RELEASE</h4>
    </div>
    <div class="press-release-card-wrapper">
        <div class="card">
            <div class="d-flex" *ngFor="let press of pressReleaseList">
                <a [routerLink]="'' + press?.id">
                    <img src="{{press.imageUrl}}" alt="press-reales">
                    <span>{{textDirection =='rtl' ? press.createdAtFormatted: press.createdAtFormatted}}</span>
                    <p>{{ textDirection == 'rtl' ? press.contentAr : press.contentEn }}</p>
                </a>
            </div>
        </div>
    </div>
</div>